import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    switch (curPageId) {
        case 'godt-at-vide':
            nextPage = 'dato';
            break;
        case 'dato':
            nextPage = 'adresse';
            break;
        case 'adresse':
            nextPage = 'beskriv-skaden';
            break;
        case 'beskriv-skaden':
            nextPage = 'hvad-skyldes-skaden';
            break;
        case 'hvad-skyldes-skaden':
            if (getValueOrDefault(formConfig, formValues, 'fejl-ved-produkt').value === 'Ja') {
                nextPage = 'beskriv-forbindelsen-til-skaden';
            } else {
                nextPage = 'om-genstande';
            }
            break;
        case 'beskriv-forbindelsen-til-skaden':
            nextPage = 'om-genstande';
            break;
        case 'om-genstande':
            nextPage = 'indhentning-af-tilbud';
            break;
        case 'indhentning-af-tilbud':
            if (getValueOrDefault(formConfig, formValues, 'erderindhentetettilbudpudbedringafskaden').value === 'Ja') {
                nextPage = 'tilbud-og-pris';
            } else {
                nextPage = 'oplysninger-om-modpart';
            }
            break;
        case 'tilbud-og-pris':
            nextPage = 'oplysninger-om-modpart';
            break;
        case 'oplysninger-om-modpart':
            if (getValueOrDefault(formConfig, formValues, 'doYouHaveInformationAboutOthersInvolved').value === 'Ja') {
                nextPage = 'om-modparten';
            } else {
                nextPage = 'dokumentation';
            }
            break;
        case 'om-modparten':
            nextPage = 'dokumentation';
            break;
        case 'dokumentation':
            nextPage = 'politi-og-samtykke';
            break;
        case 'politi-og-samtykke':
            if (getValueOrDefault(formConfig, formValues, 'policeContacted').value === 'Y') {
                nextPage = 'samtykke';
            } else {
                nextPage = 'om-virksomheden';
            }

            break;
        case 'samtykke':
            nextPage = 'om-virksomheden';
            break;
        case 'om-virksomheden':
            nextPage = 'forsikringsmaegler';
            break;
        case 'forsikringsmaegler':
            nextPage = 'andet-selskab';

            break;
        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                nextPage = 'hvilket-selskab';
            } else {
                nextPage = 'om-dig';
            }
            break;
        case 'hvilket-selskab':
            nextPage = 'om-dig';
            break;
        case 'om-dig':
            nextPage = 'resume';
            break;
        case 'resume':
            nextPage = undefined;
            break;
        default:
            console.log('# curPageId=', curPageId);
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
